module.exports = __webpack_public_path__ + "static/media/icn-subnav-company.39915ccc.svg";